module.exports = __webpack_public_path__ + "img/달건이.0b526149.png";